import Event from '@oppobrowser/lib-browser-event';
import { $, showToast, throttle, debounce } from '@js/utils';
import { isBrowserVersionHigherThan } from '../../js/utils';
import wv from '@cpc/lib-browser-jsapi';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import { _docId, isSmallRedBook } from '../../js/constants';
import ListItemFeedback from '../../js/listItemFeedback';
import Feedback from '../../js/feedback.js';
import { bizTraceCacheGet, getBizTraceInfo } from '@js/native';

const EventHandler = {
  // 点击媒体号除关注按钮区域的处理函数
  openMediaDetail(node, event) {
    let reportData = this.mediaInfo;
    console.log(reportData, 'reportData');
    reportData.clickPage = 'relatedCard';
    reportData.bizTrace =
      bizTraceCacheGet(_docId)?.value || getBizTraceInfo() || '';
    this.openDetail(reportData);
    // setTimeout(() => {
    //   wv.openDetail && wv.openDetail(reportData);
    // }, 300);
  },
  // 点击关注按钮的处理函数
  follow(node, e) {
    const { media, isSubscribe } = this;
    const { name, vendor, outId } = media;
    e.stopPropagation();
    window.store.cardContent.isCard = false;
    // V7.22版本及以上关注接口需传五个参数
    if (isBrowserVersionHigherThan('7.22')) {
      console.log(
        '12345',
        outId,
        name,
        'oppo',
        !isSubscribe,
        JSON.stringify({ docId: _docId }),
      );
      wv.subscribe &&
        wv.subscribe(
          outId,
          name,
          'oppo',
          !isSubscribe,
          JSON.stringify({ docId: _docId }),
        );
    } else {
      console.log(
        '1234567',
        outId,
        name,
        'oppo',
        !isSubscribe,
        JSON.stringify({ docId: _docId }),
      );

      wv.subscribe && wv.subscribe(outId, name, 'oppo', !isSubscribe);
    }
    this.mediaNoReturned = outId;

    console.log('follow', media, _docId);
    // 本地环境
    if (this.env) {
      this.isSubscribe = !isSubscribe;
      this.focusStatusChangeCallback(this.media.outId, this.isSubscribe);
    }
  },
  // 点击关注按钮旁，卡片列表展开相关的箭头元素的处理函数
  showCard(node) {
    this.arrowDirection = !this.arrowDirection;
    this.informCard(!this.arrowDirection);
    this.arrowAnimation();
  },
};

export default class MediaBar {
  constructor(el, name, data = {}) {
    this.el = el;
    this.media = window.store.media;
    this._eventHandler = {};
    this.isSubscribe = false; // 媒体号关注状态 默认未关注
    this.mediaNoReturned = ''; // 回调给详情页的媒体号（用户上一步操作的媒体号）
    // 滚动相关变量
    this.authorAvatarHeight = 0;
    this.mediaBarOffsetTop = 0;
    this.lastPercent = undefined;

    this.isInitStyle = true; // 初次进入页面的标记
    // 获取相关element
    this.mediaBtn = $('.document-media__follow'); // 又名follow
    this.foucusBtnBox = $('.document-media__content__box'); // 原content
    this.arrow = $('.document-media__show__box'); // 原show
    this.line = $('.document-media__line__box');

    this.authorAvatar = $('#author-avatar', this.el);
    this.authorCardDom = $('#author-card', this.el);
    this.media_show = $('.document-media__show');
    this.card = $('.card');
    this.contentBox = $('.document-media__author__box');
    this.env = window.pageData.COMMON.ENV === 'development';
    // this.env = false;
    this.summary = $('.document-media__summary');
    // 控制卡片展示的变量
    this.isHasCardListMethod = false; // 是否具有卡片数据
    this.isShowCardByStrategy = true; // 根据策略确定的卡片是否展示 0不显示,1显示 原为 showData
    this.callbackTime = 0;
    this.arrowDirection = true; // false代表箭头向下、卡片展开，true代表箭头向上、卡片收起
    this.openDetail = debounce(this.openDetail.bind(this), 300, false);
  }

  openDetail(reportData) {
    wv.openDetail && wv.openDetail(reportData);
  }

  init() {
    this.getData();
    this.preProcess();
    this.registeEventAndCallback();
    this.callbackTime = new Date().valueOf();
    if (this.env) {
      this.focusStatusChangeCallback(this.media.outId, this.isSubscribe);
    }
  }

  getData() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this.isHasCardListMethod = this.env
      ? true
      : window.wv.isMethodValid('BrowserIFlow.requestCardList');
    // '1,0'第一个取值为文章详情页是否展示，第二个取值为视频详情页是否展示;不展示：0；展示：1；
    // this.isShowCardByStrategy = this.env ? true : window.wv.isMethodValid('getConfigValue') ? !!Number(window.wv.invoke('getConfigValue', 'ABTest.relatedCard').data?.split(',')[0]) : false;
    this.isShowCardByStrategy = window.modulesConfig?.card?.isShow;
  }

  preProcess() {
    const that = this;
    this.exposeCard();
    this.touchContent();
    // 按压反馈
    this.authorCardDom && new ListItemFeedback(this.authorCardDom);

    // 解决按压 反馈异常 点击此处 不需要按压反馈
    this.foucusBtnBox?.addEventListener(
      'touchstart',
      (e) => {
        if (!that.authorCardDom) return;
        that.authorCardDom._ripple.touched = true;
        that.authorCardDom._ripple.isTouch = true;
      },
      {
        passive: false,
      },
    );

    if (!this.mediaBarOffsetTop) {
      this.mediaBarOffsetTop = $('.document__title').offsetHeight;
      //直接刷新页面时，页面可能在中间，需要直接显示媒体号
      this.scrollEventHandler();
    }

    // 小红书直接展示出客户端媒体号 无论滚动到哪里都显示
    isSmallRedBook &&
      window.wv.invoke('BrowserIFlow.onIFlowHtmlMediaScrollProcessChanged', 1);
  }

  registeEventAndCallback() {
    // 点击事件的回调
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
    // 打开详情页、点击顶部bar栏关注按钮的客户端回调
    wv.syncSubState &&
      wv.syncSubState((mediaNo, isSubscribed) => {
        this.focusStatusChangeCallback(mediaNo, isSubscribed);
      });
    // 详情页点击关注按钮，调用subscribe方法后的客户端回调
    wv.onSubscribe &&
      wv.onSubscribe((result) => {
        if (!result) {
          showToast('关注失败');
        } else {
          console.log(
            '关注回调成功',
            this.isHasCardListMethod,
            this.isSubscribe,
          );
          if (!this.isHasCardListMethod) {
            this.focusStatusChangeCallback(this.media.outId, !this.isSubscribe);
          }
        }
      });
    // 删除所有卡片后的回调
    EventEmit.instance.on('isUp', this.isUp.bind(this));
    // 注册媒体号相关的滚动逻辑
    if (this.useMediaBar) {
      window.addEventListener(
        'scroll',
        throttle(this.scrollEventHandler.bind(this), 30, true),
        false,
      );
      // 用于告知客户端当前媒体号的详细信息，点击关注/取消关注时供客户端使用
      wv.onReceiveMediaInfo && wv.onReceiveMediaInfo(this.mediaInfo); // 打开文章详情页获取到媒体号信息
    }
  }

  focusStatusChangeCallback(mediaNo, isSubscribed) {
    if (this.isInitStyle) {
      this.callbackTime = new Date().valueOf() - this.callbackTime;
      this.isSubscribe = !!Number(isSubscribed); // 避免客户端传字符串“0”，导致关注状态错误
      window.store.status = isSubscribed;
      this.focusBtnAndIntroductionAnimation(this.isInitStyle); // 初始化时只做关注区域的动画
      this.isInitStyle = false;
      return;
    }
    console.log(
      'syncSubState',
      mediaNo,
      '*',
      this.media.outId,
      '*',
      isSubscribed,
    );
    this.mediaNoReturned = mediaNo;
    console.log(this.isHasCardListMethod, this.isShowCardByStrategy);
    // 卡片内点击关注客户端也会回调syncsubstate ，故通知卡片即可
    if (this.isHasCardListMethod && this.isShowCardByStrategy) {
      console.log('卡片回调', mediaNo, !!Number(isSubscribed));
      EventEmit.instance.emit(
        'cardStatusChangeCallback',
        mediaNo,
        !!Number(isSubscribed),
      );
    }

    if (this.mediaNoReturned !== this.media.outId) {
      // if(false){  // 避免客户端媒体号与文章媒体号不一致导致初始化不出现按钮的情况，会影响卡片和媒体号的关注
      console.log('关注的媒体号与详情页媒体号不一致');
      return;
    } else {
      this.isSubscribe = !!Number(isSubscribed); // 避免客户端传字符串“0”，导致关注状态错误
      window.store.status = isSubscribed;
      if (this.isHasCardListMethod && this.isShowCardByStrategy) {
        this.informCard(this.isSubscribe);
      }
      this.focusBtnAndIntroductionAnimation(); // 关注区域的动画
    }
  }

  // 通知卡片 shown代表通知卡片展开或隐藏
  informCard(shown) {
    let reportData = {
      mediaId: this.media.id,
      mediaName: this.media.name,
    };
    EventEmit.instance.emit('cardListEvent', shown, reportData);
  }

  focusBtnAndIntroductionAnimation() {
    const {
      mediaBtn, // follow
      foucusBtnBox, // 原content
      arrow, // 原show
      line,
      contentBox,
    } = this;
    if (!foucusBtnBox || !mediaBtn) {
      return;
    }
    foucusBtnBox.dataset.follow = this.isSubscribe ? 1 : 0;

    if (this.isSubscribe) {
      mediaBtn.innerHTML = '已关注';
      // 控制简介最大宽度 旧版不用算箭头 新版需要
      if (this.isHasCardListMethod && this.isShowCardByStrategy == true) {
        contentBox && contentBox.classList.add('new_flowed_maxWidth');
        arrow.classList.add('show');
        line.classList.add('show');
        if (this.isInitStyle) this.arrowDirection = true;
        else this.arrowDirection = false;
        this.arrowAnimation();
      } else {
        contentBox && contentBox.classList.add('old_flowed_maxWidth');
        mediaBtn.classList.add('bar_followed__old');
      }
    } else {
      mediaBtn.innerHTML = '关注';
      // 控制简介最大宽度 旧版不用算箭头 新版需要
      if (this.isHasCardListMethod && this.isShowCardByStrategy == true) {
        arrow.classList.remove('show');
        line.classList.remove('show');
        contentBox && contentBox.classList.remove('new_flowed_maxWidth');
      } else {
        contentBox && contentBox.classList.remove('old_flowed_maxWidth');
      }
    }
  }

  // 关注区域箭头动画
  arrowAnimation() {
    if (this.arrowDirection) {
      this.media_show.classList.add('document-media__show_up');
    } else {
      this.media_show.classList.remove('document-media__show_up');
    }
  }

  // 删除所有卡片的事件处理函数
  isUp() {
    this.arrowDirection = true;
    this.arrowAnimation();
  }

  // 判断卡片是否在可视范围内,在的话做动画,不在的话取消动画,不然会出现抖动问题
  exposeCard() {
    let that = this;
    var observer = new IntersectionObserver((entries) => {
      entries.forEach((item) => {
        if (item && item.isIntersecting) {
          that.card.classList.add('card__transition');
        } else {
          that.card.classList.remove('card__transition');
        }
      });
    });

    let newArr = Array.from(document.querySelectorAll('.card'));
    newArr.forEach((item) => observer.observe(item));
  }
  touchContent() {
    if (!window.wv.isMethodValid('BrowserIFlow.setForbidSlide')) {
      // 文档和chrome中都找不到setForbidSlide属性
      return;
    }
    let content = document.querySelector('.body');
    content.addEventListener('touchstart', function (e) {
      window.wv.invoke('BrowserIFlow.setForbidSlide', false);
    });
  }

  scrollEventHandler() {
    if (this.barVersion < 5) {
      //this.oldVersionScroll()
    } else {
      this.newVersionScroll();
    }
  }

  newVersionScroll() {
    const authorAvatar =
      this.authorAvatar || (this.authorAvatar = $('#author-avatar', this.el));
    const authorAvatarRect = authorAvatar.getBoundingClientRect();
    const followBtnPageY = authorAvatarRect.top;
    const offsetHeight =
      this.authorAvatarHeight ||
      (this.authorAvatarHeight = authorAvatar.offsetHeight);

    let percent = (-followBtnPageY / offsetHeight).toFixed(3); // 中间传值高度取3位小数
    percent = Math.max(0, percent); // 最小取0
    percent = Math.min(1, percent); // 最大取1
    if (this.lastPercent !== percent) {
      this.lastPercent = percent;
      window.wv.invoke(
        'BrowserIFlow.onIFlowHtmlMediaScrollProcessChanged',
        percent,
      );
    }
  }

  get barVersion() {
    if (process.env.NODE_ENV === 'development') {
      return 6;
    }
    if (window.wv.isMethodValid('BrowserIFlow.getIFlowHtmlVersion')) {
      return window.wv.invoke('BrowserIFlow.getIFlowHtmlVersion').data;
    }
    return 0;
  }
  get useMediaBar() {
    if (process.env.NODE_ENV === 'development') {
      return !!1;
    }
    return (
      wv.featureQuery &&
      wv.featureQuery('isH5MediaBar') &&
      !window.store.quickGameResourceId &&
      !isSmallRedBook
    );
  }

  // 媒体号信息，调用客户端接口时使用
  get mediaInfo() {
    const { outId, id, name, avatar, summary, verify } = this.media;
    let source = window.store.source == 'tencent' ? 'tencent' : 'oppo';
    return {
      mediaNo: outId,
      mediaId: id,
      name,
      avatar,
      summary,
      source,
      verify,
    };
  }
  render() {
    // 保留这个方法，避免报错
    const FeedbackBtn = $('.document-media__content__box', this.el);
    FeedbackBtn && new Feedback(FeedbackBtn);
  }
}
